import styled from 'styled-components/macro';

export const Icon = styled.span`
  margin-right: 8px;
`;
